<template id="producte-edit">
  <div class="maxw">
    <h2>Editar Producte</h2>
    <b-form v-on:submit.prevent="updateProducte">
      <b-row>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Producte:"
            label-for="input-nombre"
          >
            <b-form-input
              id="input-nombre"
              v-model="producte.nombre"
              required
              autofocus
              placeholder="Enter name"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Descripció:"
            label-for="input-desc"
          >
            <b-form-input
              id="input-desc"
              maxlength="200"
              v-model="producte.descripcion"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-form-group
            label="Unitats:"
            label-class="font-weight-bold"
            label-for="input-unit"
          >
            <b-form-input
              type="number"
              :number="true"
              required
              id="input-unit"
              v-model="producte.unitats"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
            label="Preu unitari: (€)"
            label-class="font-weight-bold"
            label-for="input-preu"
          >
            <b-form-input
              type="number"
              step="0.01"
              min="0.00"
              :number="true"
              required
              id="input-preu"
              v-model="producte.precio"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Preu Base: (€)">
            {{ calculaPreu }}
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
            label="Dte: (%)"
            label-class="font-weight-bold"
            label-for="input-preu"
          >
            <b-form-input
              type="number"
              step="0.01"
              min="0.00"
              :number="true"
              required
              id="input-preu"
              v-model="producte.descuento"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Dte: (€)">
            {{ calculaDescompte }}
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Import: (€)">
            {{ (producte.import = calculaImport) }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-form-group label="Dies Facturació:" label-for="input-fact">
            <b-form-input
              id="input-fact"
              type="number"
              :number="true"
              required
              v-model="producte.diasFacturacion"
              placeholder="Periode (nombre de dies) de facturació."
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Repetitiu:" label-for="input-rep">
            <b-form-checkbox
              v-model="producte.isRecurrente"
              name="check-button"
              switch
            >
              Facturació Recurrent (vs Unica)
              <b>(Checked: {{ producte.isRecurrente }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Actiu:" label-for="input-rep">
            <b-form-checkbox
              v-model="producte.isActive"
              name="check-button"
              switch
            >
              <b>(Actiu: {{ producte.isActive }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit"
            >Save</b-button
          >
          <b-button class="mr-2" variant="outline-primary"
            ><router-link :to="{ name: 'Productes' }"
              >Cancel</router-link
            ></b-button
          >
        </b-col>
      </b-row>
      <b-form-input
        :hidden="true"
        type="text"
        v-model="producte.identifier"
      ></b-form-input>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  props: {
    producte: {
      identifier: null,
      nombre: null,
      descripcion: null,
      precio: null,
      unitats: null,
      descuento: null,
      diasFacturacion: null,
      isRecurrente: null,
      isActive: null,
      import: null
    }
  },
  data () {
    return {
      show: true,
      isSaving: false,
      isDataSaved: false
    }
  },
  computed: {
    calculaPreu: function () {
      return this.producte.precio * this.producte.unitats
    },
    calculaDescompte: function () {
      return -this.calculaPreu * (this.producte.descuento / 100)
    },
    calculaImport: function () {
      return this.calculaPreu + this.calculaDescompte
    }
  },
  beforeRouteLeave(to, from, next) {
    // Si acabamos de guardar o estamos guardando, permitir navegación
    if (this.isDataSaved || this.isSaving) {
      next();
      return;
    }

    // Si hay cambios sin guardar, mostrar confirmación
    this.$bvModal.msgBoxConfirm(
      'Tens canvis sense desar. Vols sortir sense desar els canvis?',
      {
        title: 'Confirmar sortida',
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Sortir sense desar',
        cancelTitle: 'Cancel·lar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }
    ).then(value => {
      if (value) {
        next(); // Usuario confirma salir
      } else {
        next(false); // Usuario cancela
      }
    }).catch(() => {
      // Si el modal se cierra de otra forma, cancelar navegación
      next(false);
    });
  },
  methods: {
    updateProducte () {
      this.isSaving = true; // Indicar que estamos guardando
      
      (async () => {
        await DataAccess.putData('/api/products', this.producte.identifier, {
          identifier: this.producte.identifier,
          nombre: this.producte.nombre,
          descripcion: this.producte.descripcion,
          precio: this.producte.precio,
          unitats: this.producte.unitats,
          diasFacturacion: this.producte.diasFacturacion,
          isRecurrente: this.producte.isRecurrente,
          isActive: this.producte.isActive,
          descuento: this.producte.descuento,
          import: this.producte.import
        })
          .then(response => {
            this.isDataSaved = true; // Marcar como guardado exitoso
            this.$router.push({ name: 'Productes' })
          })
          .catch(error => {
            this.isSaving = false; // Resetear bandera si hay error
            console.log('ERROR: ', error)
          })
      })()
    }
  }
}
</script>

<style scoped>
.maxw {
  width: 80%;
  margin: 40px auto;
}
</style>
